import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

import { SocketService } from './socket.service';

@Injectable()
export class DbService{
	public serverUrlReal: string = "http://5.97.133.3"; //"http://172.28.123.3";
	public serverUrl: string = "http://www.riscossionecoattiva.egov.regione.abruzzo.it";
	public serverPort: string = "50022"; //"80";
	public baseUrl = this.serverUrl+"/proxy/api.php";
	public headers: HttpHeaders;
	public headersPDF: HttpHeaders;

	_ComuneIdObserver: any;
	comuneId$ = new Observable((observer: any) => {
		this._ComuneIdObserver = observer;
	}).share();

	constructor(private httpClient: HttpClient, public socketService: SocketService){
		console.log("SRV|DB - ALIVE!");
		this.headers = new HttpHeaders()
			.append('Content-Type', 'application/json')
			.append('Accept', 'application/json');
		this.headersPDF = new HttpHeaders()
			.append('Content-Type', 'multipart/form-data')
			.append('responseType', 'blob');

		if(!this.socketService.getSocket())
			this.socketService.startSocket(this.serverUrlReal, this.serverPort);
	}

	getElementsByKey(table: any, what = "false", key = "all", comune_id = null){
		let url = this.baseUrl+"/elem/"+table+"/"+what+"/"+key;
		if(comune_id)
			url = url+"/"+comune_id;
		else
			url = url+"/false";
		return this.httpClient.get<any>(url);
  	}

	getElementsByTable(table: any, comune_id = null){
		let url = this.baseUrl+"/table/"+table+"/false/all";
		if(comune_id)
			url = url+"/"+comune_id;
		else
			url = url+"/false";
		return this.httpClient.get<any>(url);
	}

	getElementsByQuery(name: any, table: any = null, filters = [], comune_id = null){
		let localBody: any = {};
		let url = this.baseUrl;

		localBody["prex"] = "name";
		localBody["name"] = name;
		localBody["filters"] = filters;
		if(table)
			localBody["table"] = table;
		if(comune_id)
			localBody["comuneId"] = comune_id;
		//console.log("SRV|DB - GETELEMENTSBYQUERY", localBody);
		let body = JSON.stringify(localBody);
		return this.httpClient.post<any>(url, body, { headers: this.headers });
	}

	runQuery(name: any, filters = [], sets = {}, comune_id = null){
		let url = this.baseUrl;
		let localBody: any = {};
		let localSets: any = sets;

		localBody["prex"] = name;
		if(comune_id)
			localBody["comuneId"] = comune_id;
		localBody["filters"] = filters;
		if(sets){
			Object.keys(sets).map((key) => {
				switch(key){
					case "id":
					case "local_id":
					case "comune_id":
						break;
					default:
						localSets[key] = localSets[key];
				}
			});
		}
		localBody["sets"] = localSets;
		//console.log("SRV|DB - RUNQUERY", localBody);
		let body = JSON.stringify(localBody);
		return this.httpClient.post<any>(url, body, { headers: this.headers });
	}

	insertElement(table: any, sets: any, comune_id = null){
		let paramInsert: any = {};
		let localSets: any = {};
		let url = this.baseUrl;

		paramInsert["prex"] = "insert";
		paramInsert["table"] = table;
		if(comune_id)
			paramInsert["comuneId"] = comune_id;

		Object.keys(sets).map((param) => {
			switch(param){
				case "id":
				case "local_id":
				case "comune_id":
					break;
				default:
					localSets[param] = sets[param];
			}
		});
		paramInsert["sets"] = localSets;

		let body = JSON.stringify(paramInsert);
		return this.httpClient.post<any>(url, body, { headers: this.headers });
	}

	insertFlow(sets: any){
		let paramInsert: any = {};
		let url = this.baseUrl;

		paramInsert["prex"] = "insert";
		paramInsert["table"] = "flussi_pratica";
		paramInsert["sets"] = sets;

		let body = JSON.stringify(paramInsert);
		return this.httpClient.post<any>(url, body, { headers: this.headers });
	}

	updateElement(table: any, filters = [], sets = {}, comune_id = null){
		let url = this.baseUrl;
		let paramUpdate: any = {};
		let localSets: any = sets;

		paramUpdate["prex"] = "update";
		paramUpdate["table"] = table;
		if(filters)
			paramUpdate["filters"] = filters;
		if(comune_id)
			paramUpdate["comuneId"] = comune_id;

		Object.keys(sets).map((param) => {
			switch(param){
				case "id":
				case "local_id":
				case "comune_id":
					break;
				default:
					localSets[param] = sets[param];
			}
		});
		paramUpdate["sets"] = localSets;
		let body = JSON.stringify(paramUpdate);
		return this.httpClient.post<any>(url, body, { headers: this.headers });
	}

	deleteElement(table: any, filters = [], comune_id = null){
		//console.log("SRV|DB - DELETEELEMENT", table, filters, comune_id);
		// da rivedere
		let url = this.baseUrl;
		let paramUpdate: any = {};

		paramUpdate["prex"] = "delete";
		paramUpdate["table"] = table;
		if(filters)
			paramUpdate["filters"] = filters;
		if(comune_id)
			paramUpdate["comuneId"] = comune_id;

		let body = JSON.stringify(paramUpdate);
		return this.httpClient.post<any>(url, body, { headers: this.headers });
	}

	getUserRolesByComuneId(userId, comuneId){
		let url: string = '/api/users/get_user_roles_by_comune_id';
		let body: any = {
			userId: userId,
			comuneId: comuneId
		};
		//console.log("SRV|DB -  GETUSERSERVICES BY COMUNEID", body);
		return this.httpClient.post<any>(url, body, { headers: this.headers });
	}

	getUserServicesByComuneId(userId, comuneId){
		let url: string = '/api/users/get_user_services_by_comune_id';
		let body: any = {
			userId: userId,
			comuneId: comuneId
		};
		//console.log("SRV|DB -  GETUSERSERVICES BY COMUNEID", body);
		return this.httpClient.post<any>(url, body, { headers: this.headers });
	}

	getOperatori(levelId, comuneId){
		let url: string = '/api/users/get_operatori';
		let body: any = {
			levelId: levelId,
			comuneId: comuneId
		};
		console.log("SRV|DB - GETOPERATORI", body);
		return this.httpClient.post<any>(url, body, { headers: this.headers });
	}

	getCittadini(comuneId){
		let url: string = '/api/users/get_cittadini';
		let body: any = {
			comuneId : comuneId
		};
		return this.httpClient.post<any>(url, body, { headers: this.headers });
	}

	getAnagraficheByCf(cf: any, idComune: any){
		let url: string = '/api/users/get_anagrafiche_by_cf';
		let body: any = {
			cf : cf,
			idComune : idComune
		};
		//console.log("SRV|DB - GETANAGRAFICA BY CF", body);
		return this.httpClient.post<any>(url, body, { headers: this.headers });
	}

	createNotificaSistema(body){
		let url: string = '/api/notifiche/create';
		return this.httpClient.post<any>(url, body, { headers: this.headers })
	}

	getNotificheSistema(body){
		let url: string = '/api/notifiche/getAllByUser';
		return this.httpClient.post<any>(url, body, { headers: this.headers });
	}

	setNotificaRead(notifica: any){
		let url: string = '/api/notifiche/set_as_read';
		let body: any = {
			notifica: notifica
		};
		return this.httpClient.post<any>(url, body, { headers: this.headers })
	}

	createConversation(body){
		let url: string = '/api/conversations/create';
		return this.httpClient.post<any>(url, body, { headers: this.headers })
	}

	addMessageToConversation(body){
		let url: string = '/api/conversations/add_message';
		return this.httpClient.post<any>(url, body, { headers: this.headers })
	}

	getConversationMessages(body){
		let url: string = '/api/conversations/get_messages';
		return this.httpClient.post<any>(url, body, { headers: this.headers })
	}

	updateConversation(body){
		let url: string = '/api/conversations/update';
		return this.httpClient.post<any>(url, body, { headers: this.headers })
	}

	loadConversations(body){
		let url: string = '/api/conversations/get_all';
		return this.httpClient.post<any>(url, body, { headers: this.headers })
	}

	addAllegatoToConversation(body){
		let url: string = '/api/conversations/add_allegato';
		return this.httpClient.post<any>(url, body, { headers: this.headers })
	}

	getConversationAllegati(body){
		let url: string = '/api/conversations/get_allegati';
		return this.httpClient.post<any>(url, body, { headers: this.headers })
	}

	downloadAllegatoFromConversation(body){
		let url: string = '/api/downloads/allegato';
		return this.httpClient.post<any>(url, body, { headers : this.headersPDF })
	}
}
